import '../scss/app.scss';
import $ from 'jquery';
// require('./polyfills');
import 'what-input';
import 'slick-carousel';
import 'magnific-popup';
import Locator from './lib/locator';
import EmbeddedMap from './lib/EmbeddedMap';
import inspPopup from './lib/inspPopup';
import loadMore from './lib/loadMore';
import youtubePopup from './lib/youtubePopup';

window.$ = $;
window.jQuery = $;

//import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

$(document).foundation();

// Nav pullout
// =============
$('#fixedSideNav').bind('on.zf.toggler off.zf.toggler', function () {
    $('body').toggleClass('active-nav-pullout');
});

$('.nav-pullout-overlay').on('click', function () {
    setTimeout(function () {
        $('body').removeClass('active-nav-pullout');
        $('#fixedSideNav').removeClass('show');
    }, 150);
});

// Search Hover
// =============
if ($(window).width() > 1024) {
    // $('.searchToggle').on('click', function(e) {
        // Needs focus on click
    // });
}

// Inputtext animation classes
// =============
$('[data-inputAnimation]').focus(function () {
    $(this).parent().parent().addClass("focus");
}).blur(function () {
    if ($(this).val() != "") {
        $(this).parent().parent().addClass("hasValue");
    }
    else {
        $(this).parent().parent().removeClass("hasValue");
    }
    $(this).parent().parent().removeClass("focus");
});

// Custom Dropdown
// =============
var prevColor = $('#color-big-prev');
$(document).ready(function() {
    $('[data-customDropdown]').each(function(){
        let $item = $(this).find('input[type="radio"]:checked');
        let $label = $item.closest('label');
        let value = $label.text();
        if ($item) {
            if (value) {
                $(this).closest('.c-dd').find('input[type="hidden"]').val(value);
                $(this).closest('.c-dd').find('button').text(value);
            }

            if ($label.prev('.color-dropdown-item').length) {
                var clr = $label.prev('.color-dropdown-item').css("background-color");
                dropdownColor(clr);
            }
        }
    })
});

// Custom Input File
// ==========

function submitImageInputFile(){
    $('.cs-file:input[type="file"]').on('change', function(){
      var fileName, label;
      fileName = $(this).val().split('\\').pop();
      $(this).prev().css('opacity', '1').text(fileName);
      $(this).parents('.inputWrapOuter').addClass('hasValue');
    });
};

$('[data-customDropdown] button').on('click', function () {
    $(this).closest('.c-dd').toggleClass('is-active');
});
$('.c-dd .dropitemList label').on('click', function () {
    $(this).closest('.c-dd').find('input[type="hidden"]').val($(this).text());
    $(this).closest('.c-dd').find('button').text($(this).text());
    $(this).closest('.c-dd').removeClass('is-active');
    if ($(this).prev('.color-dropdown-item').length) {
        var clr = $(this).prev('.color-dropdown-item').css("background-color");
        dropdownColor(clr);
    }
});


function dropdownColor(color) {
    prevColor.css("background", color);
    prevColor.find('.dots').remove();
}

// Slider Tab Menu
$('.sliderTabMenu').slick({
    autoplay: false,
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1,
                arrows: false,
                centerMode: true,
                centerPadding: '250px'
            },
        },
        {
            breakpoint: 991,
            settings: {
                centerMode: true,
                slidesToShow: 1,
                arrows: false,
                centerPadding: '200px'
            }
        },
        {
            breakpoint: 767,
            settings: {
                centerMode: true,
                slidesToShow: 1,
                arrows: false,
                centerPadding: '180px'
            }
        },
        {
            breakpoint: 639,
            settings: {
                centerMode: true,
                slidesToShow: 1,
                arrows: false,
                centerPadding: '150px'
            }
        },
        {
            breakpoint: 567,
            settings: {
                centerMode: true,
                slidesToShow: 1,
                arrows: false,
                centerPadding: '120px'
            }
        },
        {
            breakpoint: 450,
            settings: {
                centerMode: true,
                slidesToShow: 1,
                arrows: false,
                centerPadding: '95px'
            }
        },
        {
            breakpoint: 375,
            settings: {
                centerMode: true,
                slidesToShow: 1,
                arrows: false,
                centerPadding: '80px'
            }
        }
    ]
});
$('.sliderTabContent').slick({
    responsive: [
        {
            breakpoint: 640,
            settings: {
                centerPadding: '0',
                arrows: true
            }
        }
    ]
});

// Slider Progress bar state
// =============

function getSliderTabWidth() {
    var width = 0;
    width = $('[data-hasProgress] .menuItem').find('span').outerWidth();
    return width;
}

function initSliderBarTabWidth() {
    var width = 0;
    width = $('[data-hasProgress] .menuItem').find('span').outerWidth();
    $('.sliderProgressBar').css({width: width + 'px'});
    return width;
}

function slideProgressSteps(nextSlide) {
    var slideIndex, currentWidth, getWidth;

    slideIndex = nextSlide;
    currentWidth = getSliderTabWidth();

    for (var i = 0; i != slideIndex; i++) {
        getWidth = getSliderTabWidth();
        currentWidth += getWidth;
    }
    sliderProgressBarWidth(currentWidth);
}

function sliderProgressBarWidth(barWidth) {
    $('[data-barContainer] .sliderProgressBar').css({width: barWidth + 'px'});
}

initSliderBarTabWidth();

$('.sliderTabContent').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    slideProgressSteps(nextSlide);
});

// Update slider tab height upon click trigger
$('.sliderTabContent').on('click', function () {
    var slidertab = $(this);
    slidertab.slick("setOption", '', '', true);
});

// Product Detail Gallery
// =============

$('#slider-product-preview').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
    draggable: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: '#slider-product-thumbs'
});

$('#slider-product-preview-large').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
    draggable: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: '#slider-product-thumbs'
});

$('#slider-product-thumbs').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '#slider-product-preview',
    focusOnSelect: true,
    fade: false,
    infinite: false,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 1361,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 641,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                centerPadding: '45px'
            }
        },
        {
            breakpoint: 501,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                centerPadding: '50px'
            }
        },
        {
            breakpoint: 401,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                centerPadding: '75px'
            }
        },
        {
            breakpoint: 375,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                centerPadding: '50px'
            }
        }
    ]
});

$('#slider-product-thumbs-large').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '#slider-product-preview-large',
    focusOnSelect: true,
    fade: false,
    infinite: false,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 1361,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 641,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                centerPadding: '45px'
            }
        },
        {
            breakpoint: 501,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                centerPadding: '50px'
            }
        },
        {
            breakpoint: 401,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                centerPadding: '75px'
            }
        },
        {
            breakpoint: 375,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
                infinite: true,
                centerPadding: '50px'
            }
        }
    ]
});


// Items Thumbnail Carousel
// ==============

$('.carousel-thumbnails').slick({
    responsive: [
        {
            breakpoint: 1921,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 801,
            settings: {
                slidesToShow: 2,
                centerMode: true,
                centerPadding: '100px'
            }
        },
        {
            breakpoint: 568,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '150px'
            }
        },
        {
            breakpoint: 481,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '90px'
            }
        },
        {
            breakpoint: 375,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '68px'
            }
        }
    ]
});


// Video Play Toggle for youtube iframe
// =============

function YTiframeAPI() {
    var tag = document.createElement('script');
    tag.id = 'iframe-sewrew';
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function onYouTubeIframeAPIReady(id) {
    var player = new YT.Player(id, {
        events: {
            'onReady': onPlayerReady
        }
    });
}

function onPlayerReady(e) {
    e.target.playVideo();
}

$('[data-video]').on('click', function () {
    var vid;
    $(this).find('.video-thumb').addClass('visually-hidden');
    vid = $(this).find('iframe').attr('id');
    YTiframeAPI();
    $(this).delay(350).queue(function () {
        onYouTubeIframeAPIReady(vid);
    });
});

// Color Tooltip
// =============

// append tooltip template
$('[data-colortip]').each(function () {

    const clrHex = $(this).attr('data-colorhex'),
    clrName = $(this).attr('data-colorname'),
    clrSecHex = $(this).attr('data-secondcolorhex'),
    clrImage = $(this).attr('data-colorimage');
    let imgColorText = '';
    if (!clrImage) {
        imgColorText = `
        <span class='clrHex'> #${clrHex} </span>
        ${ clrSecHex ? "<span class='clrSecHex'>over #" + clrSecHex + "</span>" : "" }
    `;
    }
    $(this).append(
        `<div class='tip-color'>
            <div class='color-hex-prev'></div>
            <div class='color-hex-second'></div>
            <div class='color-details'>
                ${imgColorText}
                <span class='clrName'> ${clrName} </span>
            </div>
        </div>`
    );

    $(this).parent().find('.color-hex-prev').css("background", '#' + clrHex);
    $(this).parent().find('.color-hex-second').css("background", '#' + clrSecHex);
    $(this).parent().find('.color-hex-prev').css("background-image", `url(${clrImage})`);

});

// See more color mask
$('[data-moremask]').each(function () {
    if ($(this).outerHeight() > 350) {
        $(this).find('.unmask').addClass('mask');
        $(this).find('.see-more').removeClass('hide');
    }
    else {
        $(this).find('.unmask').removeClass('mask');
    }
});

// Table Mobile
// ============
$('[data-tableresponsive] .tbody-tr-res').on('click', function () {
    $(this).toggleClass('expand');
});

// Accordion plus minus toggle
$('.acc-toggle').on('click', function () {
    $(this).toggleClass('show');
});


// "Load More" on the blog listing: appends the next page of cards, which
// ajax/blog.twig renders with the same card partial as the first page.
function loadMoreBlogs() {
    const $button = $('#blog-load-more');
    if (!$button.length) return;

    let loading = false;
    $button.on('click', function (e) {
        e.preventDefault();
        if (loading) return;

        const nextPage = parseInt($button.data('nextPage'), 10);
        const totalPages = parseInt($button.data('totalPages'), 10);
        const category = $button.data('blogCategory');

        loading = true;
        $.get('/ajax/blog/p' + nextPage, category ? { category: category } : {})
            .done(function (html) {
                $('.blog-listing-content').append(html);
                $button.data('nextPage', nextPage + 1);
                if (nextPage >= totalPages) {
                    $button.hide();
                }
            })
            .always(function () {
                loading = false;
            });
    });
}

function setupLocator() {
    let $locatorForm = $('.distributorLocator');
    if (!$locatorForm.length) return;

    Locator.attach($locatorForm);
}

function setupEmbeddedMap() {
    let $embeddedMapView = $('.embeddedMapView');
    if (!$embeddedMapView.length) return;

    EmbeddedMap.attach($embeddedMapView);
}

$(document).ready(function () {
    // do stuff when the page loads
    setupLocator();
    setupEmbeddedMap();
    loadMoreBlogs();
    inspPopup();
    loadMore();
    youtubePopup();
    submitImageInputFile();
});
